import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14 10L9 15M9 15L2.67258 11.1062C2.60199 11.0628 2.61185 10.9572 2.68927 10.9276L19.291 4.57993C19.3717 4.54905 19.4509 4.62829 19.4201 4.70905L16.8235 11.5M9 15L12 19.875"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M15 17.5H20M17.5 15V20"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
